// extracted by mini-css-extract-plugin
export default {"roller":"InitialLoading_roller__B47-l","blackBg":"InitialLoading_blackBg__ArkeL"};